module.exports = __webpack_public_path__ + "img/verified_review.09d5d01e.svg";